import ErrorMessage from "../components/UI/ErrorMessage";

const NotFound = () => {
  return <ErrorMessage />;
};

export default NotFound;
